import { cn } from 'utils/utils';
import { NavLink } from 'react-router-dom';

const NavigationLink = ({
  children,
  href,
  className,
}: {
  children: React.ReactNode;
  href: string;
  className?: string;
}) => {
  return (
    <NavLink
      to={href}
      className={({ isActive }) =>
        cn(
          'text-white hover:text-brand-brown font-[MuseoSans900] tracking-[1.5px] normal-case',
          className,
          isActive &&
            'active text-brand-brown underline decoration-brand-yellow decoration-2 underline-offset-4 md:bg-muted md:no-underline max-md:bg-transparent max-md:no-underline max-md:decoration-transparent'
        )
      }
    >
      {children}
    </NavLink>
  );
};

export default NavigationLink;
